// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?id=" + {"856":"c8195a3aab53cb18","861":"d8edde0a6fd98dcf"}[chunkId] + "";
};